module.exports = __webpack_public_path__ + "static/media/Linotype.f2f2f528.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Linotype.png
// module id = 79
// module chunks = 0